
import React from 'react'

const Services = () => {
    return (
        <>
            <section id="services" class="our-pricing">
                <div class="container">
                    <div class="row">
                        <h2 class="heading-title">Our Services</h2>
                        <div class="our-pricing-wrapper clearfix">
                            <article class="tabbed-content">
                                <section id="tab1" class="item active" data-title="Hair">
                                    <div class="item-content">
                                        <div class="price-list-main">
                                            <div class="price-list-full-row">
                                                <div class="price-list-row right-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">Vintag Hair Cut
                                                            </div>
                                                            <div class="price-list-service-price">$12
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p> Lorem Ipsum is ofthe printorm Ipsum is simply. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="price-list-row left-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">Hair Wash
                                                            </div>
                                                            <div class="price-list-service-price">$12
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p>Lorem Ipsum is simply dummy text ofthe Printorm Ipsum is simply. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="price-list-full-row">
                                                <div class="price-list-row right-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">Classic Hair Cut
                                                            </div>
                                                            <div class="price-list-service-price">$25
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p> Lorem Ipsum is simply dummy text ofthe printorm Ipsum is simply. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="price-list-row left-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">Hair Color
                                                            </div>
                                                            <div class="price-list-service-price">$49
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p>Hair Color Lorem Ipsum is simply dummy text ofthe Printorm Ipsum is simply. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="price-list-full-row">
                                                <div class="price-list-row right-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">Stylish Hair Cut
                                                            </div>
                                                            <div class="price-list-service-price">$34
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p> Lorem Ipsum is simply dummy text ofthe printorm Ipsum is simply. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="price-list-row left-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">TradationalHair Cut
                                                            </div>
                                                            <div class="price-list-service-price">$44
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p>Printorm Ipsum is simplysimply dummy text is simply dummy text ofthe. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="price-list-full-row">
                                                <div class="price-list-row right-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">Hair Color
                                                            </div>
                                                            <div class="price-list-service-price">$75
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p> Lorem Ipsum is simply dummy text ofthe printorm Ipsum is simply. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="price-list-row left-space">
                                                    <div class="price-list-box">
                                                        <div class="price-list-inner-box">
                                                            <div class="price-list-service-name">Hair Wash
                                                            </div>
                                                            <div class="price-list-service-price">$10
                                                            </div>
                                                        </div>
                                                        <div class="price-list-discription"> <p>Printorm Ipsum is simply Lorem Ipsum is simply dummy text ofthe. </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </section>
                            </article>
                        </div>
                        <div class="cta-box ">
                            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                                <div class="cta-box-hours"> <i class="icofont ctaclock icofont-wall-clock"></i> Opening hours: Monday - Friday:  09.00 AM - 17.00 PM
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                <div class="cta-box-btn"> <a href="/barbar" title="Make an appointment" class="cta-appoint-btn">Make an appointment now <i class="icofont icofont-long-arrow-right"></i></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Services